/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { bool } from 'prop-types';
import contentGrouper from 'TMUtils/contentGrouper';

import Container from 'TMComponents/Container';
import FlexWrapper from 'TMComponents/FlexWrapper';
import ComponentMapper from 'TMComponents/ComponentMapper';
import NavLink from 'TMComponents/NavLink';
import { BodySm, H2 } from 'TMComponents/Typography';
import { FooterContent } from 'TMComponents/Typography/styles';

import { StickyFooterConcealer } from 'TMComponents/StickyFooter';
import { breakpoints } from 'TMConstants';
import SocialMediaLink from 'TMComponents/SocialMediaLink';

const SocialLinksSection = styled.div`
    background: ${({ theme }) => theme.colorSystem.primary[3]};
    margin-left: -20px;
    margin-right: -20px;
    padding: 56px 20px;
    text-align: center;
    position: relative;
`;
const SocialHeading = styled(H2)`
    color: ${({ theme }) => theme.colorSystem.UIText[1]};
`;

const SocialLinksContent = styled(FlexWrapper)`
    padding-top: 20px;
    margin: 0 auto;
    max-width: 500px;
    justify-content: space-evenly;
`;

const MainFooter = styled.nav`
    background: ${({ theme }) => theme.colorSystem.primary[1]};
    color: ${({ theme }) => theme.colorSystem.UIText[3]};
    overflow: hidden;
`;
const MainFooterContent = styled(Container)`
    max-width: 1280px;
    padding: 30px 20px;
    &:last-child > ul {
        border-bottom: none;
        margin-bottom: 0;
    }
`;

const SubFooter = styled.nav`
    background: ${({ theme }) => theme.colorSystem.primary[4]};
    box-shadow: ${({ theme }) => theme.colorSystem.shadows[8]};
    color: ${({ theme }) => theme.colorSystem.UIText[3]};
    margin: 0;
    padding: 5px 16px;
`;

const ColumnWrapper = styled(FlexWrapper)`
    ul:last-child {
        margin-bottom: 0 !important;
    }
`;

const Column = styled.ul`
    ${FooterContent}
    margin: 0;
    margin-bottom: 40px;
    padding: 0;
    padding-left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > div > *:first-child {
        border-bottom: 1px solid
            ${(props) => props.theme.colors.greys.lightest};
    }

    & > div {
        margin: -14px 0;
    }

    @media (min-width: ${breakpoints.mobileTablet}px) {
        width: calc(25% - 32px);
        margin: 0 32px 0 auto;
    }
`;

const LastColumn = styled(Column)`
    & > div > *:first-child {
        border-bottom: none;
    }

    @media (min-width: ${breakpoints.mobileTablet}px) {
        display: ${({ hideOnDesktop }) => hideOnDesktop && 'none'};
    }

    div:nth-child(2) {
        padding-bottom: 32px;
        a:first-child {
            margin-right: 16px;
        }
    }

    p:last-child {
        padding-bottom: 16px;
    }

    div:nth-last-child(-n + 2) {
        display: inline-block;
    }
`;

const FooterLinkText = styled(BodySm)`
    margin: 0;
`;

const ListItemWrapper = styled.li`
    list-style-type: none;
    margin-bottom: 10px;
    width: 100%;
    &:last-child {
        border-right: none;
        margin-bottom: 0;
    }
    @media (min-width: ${breakpoints.mobileTablet}px) {
        width: auto;
        border-right: 1px solid
            ${(props) => props.theme.colors.greys.lightest};
        margin-bottom: 0;
        padding: 0 20px;
    }
`;
/**
 * Component w/ graphql query
 */
const Footer = ({ hideNav, hideFooterAppLinksOnDesktop }) => {
    const { footer } = useStaticQuery(graphql`
        {
            footer: datoCmsFooter {
                socialMediaLinks {
                    ... on DatoCmsSocialMediaLink {
                        __typename
                        id
                        link
                        company
                        ariaLabel
                        icon {
                            alt
                            gatsbyImageData(
                                width: 68
                                layout: FIXED
                                imgixParams: { auto: "compress" }
                            )
                        }
                    }
                }
                columnOne {
                    ... on DatoCmsColumnLink {
                        __typename
                        id
                        text
                        link
                    }
                    ... on DatoCmsColumnTitle {
                        __typename
                        id
                        text
                    }
                }
                columnTwo {
                    ... on DatoCmsColumnLink {
                        __typename
                        id
                        text
                        link
                    }
                    ... on DatoCmsColumnTitle {
                        __typename
                        id
                        text
                    }
                }
                columnThree {
                    ... on DatoCmsColumnLink {
                        __typename
                        id
                        text
                        link
                    }
                    ... on DatoCmsColumnTitle {
                        __typename
                        id
                        text
                    }
                }
                columnFour {
                    ... on DatoCmsColumnLink {
                        __typename
                        id
                        text
                        link
                    }
                    ... on DatoCmsColumnTitle {
                        __typename
                        id
                        text
                    }
                    ... on DatoCmsAppStoreLink {
                        __typename
                        id
                        link
                        image {
                            alt
                            gatsbyImageData(
                                height: 40
                                layout: FIXED
                                imgixParams: { auto: "compress" }
                            )
                        }
                        height
                        whiteBackground
                        commonOptions {
                            ...backgroundVariantFields
                            ...hideByDeviceSizeFields
                        }
                    }
                }
                bottomFooter {
                    ... on DatoCmsColumnLink {
                        __typename
                        id
                        text
                        link
                    }
                }
            }
        }
    `);

    return (
        <footer>
            {!hideNav && (
                <MainFooter>
                    <SocialLinksSection>
                        <SocialHeading>Follow us</SocialHeading>
                        <SocialLinksContent justify="center">
                            {footer.socialMediaLinks.map((item) => (
                                <SocialMediaLink
                                    key={item.id}
                                    {...item}
                                    size="lg"
                                />
                            ))}
                        </SocialLinksContent>
                    </SocialLinksSection>
                    <MainFooterContent>
                        <ColumnWrapper wrap>
                            <Column>
                                {footer.columnOne.map((item) => (
                                    <ComponentMapper
                                        key={item.id}
                                        {...item}
                                    />
                                ))}
                            </Column>
                            <Column>
                                {footer.columnTwo.map((item) => (
                                    <ComponentMapper
                                        key={item.id}
                                        {...item}
                                    />
                                ))}
                            </Column>
                            <Column>
                                {footer.columnThree.map((item) => (
                                    <ComponentMapper
                                        key={item.id}
                                        {...item}
                                    />
                                ))}
                            </Column>
                            <LastColumn
                                hideOnDesktop={
                                    hideFooterAppLinksOnDesktop
                                }>
                                {contentGrouper(footer.columnFour).map(
                                    (item) => (
                                        <ComponentMapper
                                            justify="left"
                                            key={item.id}
                                            {...item}
                                        />
                                    )
                                )}
                            </LastColumn>
                        </ColumnWrapper>
                    </MainFooterContent>
                </MainFooter>
            )}
            <SubFooter>
                <Container>
                    <FlexWrapper
                        as="ul"
                        justify="center"
                        align="center"
                        wrap>
                        {footer.bottomFooter.map(({ text, link }) => (
                            <ListItemWrapper key={text}>
                                <NavLink href={link}>
                                    <FooterLinkText>{text}</FooterLinkText>
                                </NavLink>
                            </ListItemWrapper>
                        ))}
                    </FlexWrapper>
                    <StickyFooterConcealer />
                </Container>
            </SubFooter>
        </footer>
    );
};

Footer.propTypes = {
    hideNav: bool,
    hideFooterAppLinksOnDesktop: bool
};

Footer.defaultProps = {
    hideNav: false,
    hideFooterAppLinksOnDesktop: false
};

export default Footer;
